// import searchStartHtml from "./search_templates";
import { debugHtml, searchFrameWorkHtml, resultUnit, resultContactCard, resultFile, resultDefault } from "./search_templates";
import dayjs from "dayjs";
import searchpostrender from "./search_postrender";
import { postImplementImage } from "src/scripts/mixin";

export default () => {
  const query = getUrlAttr("q");
  document.getElementById("searchframework").innerHTML = searchFrameWorkHtml(query);
  startSearch(query);
};

export const checkNested = (obj, level, ...rest) => {
  if (obj === undefined) return false;
  if (rest.length == 0 && obj.hasOwnProperty(level)) return true;
  return checkNested(obj[level], ...rest);
};

export const UpdateQueryString = (key, value) => {
  const params = new parent.URLSearchParams(parent.location.search);
  if (params.has(key)) {
    params.set(key, value);
  } else {
    params.append(key, value);
  }

  if (window.history.pushState) {
    const newURL = new URL(window.location.href);
    newURL.search = "?" + params.toString();
    window.history.pushState({ path: newURL.href }, "", newURL.href);
  }
};

/* global config, getUrlAttr, searchEngine */
var config, hits__pr__page, hits__from, sort__order, next__page, prev__page, query__text, filterText, scrollTimer;

export const startSearch = (querytext) => {
  // config = getConfig();
  query__text = decodeURIComponent(querytext);
  filterText = getUrlAttr("filter");
  hits__pr__page = 20;
  hits__from = getUrlAttr("hits__from") || 0;
  sort__order = getUrlAttr("sort__order") || "RELEVANCE";

  next__page = Number(hits__from) + Number(hits__pr__page);
  prev__page = Number(hits__from) - Number(hits__pr__page);

  haiveFind(query__text, filterText);
  haiveCategorize(query__text);
};

export const getMetadataValue = (result, metakey) => {
  const [metadata] = result.metadata.filter(function (elem) {
    return elem.name === metakey;
  });

  return metadata != null ? (metadata.value === "" ? "" : metadata.value) : "";
};

export const haiveFind = (query__text, filter) => {
  var queryFilter = BuildQueryFilter(filter);

  if (query__text.match(/a-å/gim)) {
    query__text = "*";
    sort__order = "RELEVANCE";
  }

  var query =
    ` query {      
                    index {
                        items (
                            filter: {
                                searchQuery: "` +
    query__text +
    `",       
                                skip: ${hits__from},
                                take: ${hits__pr__page},
                                queryType: MATCHANY,
                                sortBy: ${sort__order.toUpperCase()},
                                categories: ${queryFilter}
                            }                 
                        )    
                        {
                            hits,results {
                                title, date, content, id, url, relevance, extracts, 
                                metadata {
                                    name, value
                                },
                                categories {
                                    values
                                }
                            }
                        }
                    } 
                }`;

  fetch("https://prokom.aim.ayfie.com/", {
    headers: {
      //   'Accept': 'application/json',
      //   'Content-Type': 'application/json',
      ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
      "Content-Type": "application/graphql",
    },
    method: "POST",
    body: query,
  })
    .then((result) => result.json())
    .then((data) => {
      DisplaySearchResult(data);
      // console.log("leter");
      // document.getElementById("searchheader__inputfield").removeEventListener("keyup", key => {});
      searchpostrender();
      addEventListners();
    });
};
const haiveCategorize = (query__text, filter) => {
  var queryFilter = BuildQueryFilter(filter);

  const query =
    ` query {      
                    index {
                        categories (
                            filter: {
                                searchQuery: "` +
    query__text +
    `",
                                categories:  ${queryFilter}
                            }                 
                        )    
                        {
                            results {
                                categoryDisplayName
                                groupName
                                groupDisplayName
                                path
                                itemsCount  
                            }
                        }
                    } 
                }`;

  fetch("https://prokom.aim.ayfie.com/", {
    headers: {
      //   'Accept': 'application/json',
      //   'Content-Type': 'application/json',
      ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
      "Content-Type": "application/graphql",
    },
    method: "POST",
    body: query,
  })
    .then((result) => result.json())
    .then((data) => {
      DisplayCategories(data);
    });
};
const DisplaySearchResult = (data) => {
  // console.log(data);
  data = data.data;

  if (checkNested(data, "index", "items")) {
    const hits = data?.index?.items?.hits || 0;

    let resultList = [];
    const searchResultList = document.querySelector(".searchresult__list");

    const timelinecats = [];
    document.querySelectorAll("[data-navcatitem]").forEach((navcat) => {
      timelinecats.push(navcat.dataset.navcatitem);
    });

    data?.index?.items?.results?.forEach((item) => {
      let itemLayout = "";
      let debug = false;

      if (query__text.includes(":intellidebug")) {
        debug = true;
      }
      if (item.id == null) {
        searchResultList.innerHTML = formatDebugItem(item);
      } else if (!item.id.includes("Content")) {
        itemLayout = formatStatsItem(item.extracts);
      } else {
        const date = dayjs(item.date);

        item.id = getMetadataValue(item, "ContentId");
        // item.date = date;
        item.pDate = date.format("DD.MM.YYYY");
        item.pageType = getMetadataValue(item, "PageTypeId") === "" ? "file" : getMetadataValue(item, "PageTypeId");
        // console.log(item.pDate);

        if (getMetadataValue(item, "personStilling")) {
          item.contact.personstilling = getMetadataValue(item, "personStilling");
          item.contact.personMobil = getMetadataValue(item, "personMobil");
          item.contact.personEpost = getMetadataValue(item, "personEpost");
        }

        if (getMetadataValue(item, "imageContentId")) {
          item.image = getMetadataValue(item, "imageContentId");
        }

        const startDebugExtract = item.extracts.indexOf("<hr>", 0);

        let debugExtract = startDebugExtract > -1 ? item.extracts.substring(startDebugExtract).split("<b>").join("<br/><b>") : "";
        let extract = startDebugExtract == -1 ? item.extracts : item.extracts.substring(0, startDebugExtract);
        extract = extract.length < 1 ? item.content.substr(0, 500) + (item.content.length > 500 ? "..." : "") : extract;

        item.extract = extract;

        item.site = "kommuneleksikon";

        if (timelinecats.includes(item.categories[0].values[1])) {
          item.site = "tidslinje";
        }

        switch (item.pageType) {
          case "mal_enhetsmal":
            itemLayout = resultUnit(item);
            break;
          case "mal_visittkort":
            itemLayout = resultContactCard(item);
            break;
          case "file":
            itemLayout = resultFile(item);
            break;
          default:
            itemLayout = resultDefault(item);
        }

        resultList.push(itemLayout);
      }
    });

    document.getElementById("searchresultHitscount").innerHTML = hits;
    // document.querySelector(".searchresult__meta__dropdown-content").innerHTML = `<li><span>${language("SEARCH_RELEVANCE")}</span></li><li><span>${language("SEARCH_DATE")}</span></li>`;
    // document.querySelector(".searchresult__meta__choosedtxt").innerHTML = `${sort__order.toUpperCase()==="DATE" ? "Dato" : "Relevans"}`;

    const returnHtml = resultList.join("");

    searchResultList.innerHTML = returnHtml;

    postImplementImage(false);

    var useInfinityScroll = config?.InfinityScroll || false;
    if (!useInfinityScroll) {
      document.querySelector(".searchresult__pagination").innerHTML = `
                <a Xhref="/search/${query__text}?${filterText != null ? "filter=" + filterText + "&" : ""}hits__from=${Number(prev__page)}${sort__order != "" ? "&sort__order=" + sort__order : ""
        }" class="searchresult__prev__page ${hits__from != 0 ? "" : "disabled"}">❮</a>
                <a Xhref="/search/${query__text}?${filterText != null ? "filter=" + filterText + "&" : ""}hits__from=${Number(next__page)}${sort__order != "" ? "&sort__order=" + sort__order : ""
        }" class="searchresult__next__page ${hits > next__page ? "" : "disabled"}">❯</a>
                <div>${Number(hits__from) + 1}-${Number(hits__from) + Number(hits__pr__page)} av ${hits}</div>`;
    }

    // document.getElementById("searchheader__inputfield").value = query__text;
  }

  //     if (hits === 0) {
  //         document.querySelector(".searchresult__meta").innerHTML = `
  //                 <div class="searchresult__count">${language("SEARCH_TOTALHITS")}: 0</div>
  //                 <div class="searchresult__showcount">${language("SEARCH_NOHITS_DESC")}</div>
  //             `
  //         $(".searchresult__pagination").html("");
  //
  // }
};
const DisplayCategories = (data) => {
  // console.log("DisplayCategories", data);
  const categoriesCollection = document.querySelector(".categories__collection");
  data = data.data;
  let currentGroup = "";
  data.index.categories.results.forEach((result) => {
    if (
      result.groupName.toLowerCase() == "contentsubscribers" ||
      result.groupName.toLowerCase() == "subscriptionid" ||
      result.groupName.toLowerCase() == "date" ||
      result.groupName.toLowerCase() == "language" ||
      result.groupName.toLowerCase() == "pagetype"
    ) {
      return false;
    }
    if (currentGroup != result.groupName) {
      let catHead = `<div class="categories__group">
                    <h4 class="categories__listheader">
                        <div class="categories__listheaderlink">
                        <span>${result.groupDisplayName === "Categories" ? "Kategorier" : result.groupDisplayName}</span>
                        <span class="icon material-icons-outlined">&#xe5ce</span>
                        </div>
                    </h4>
                    <ul class="categories__listgroup list-group" data-category_group="${result.groupName}" ></ul></div>`;
      categoriesCollection.innerHTML += catHead;
    } else {
    }
    currentGroup = result.groupName;
    const categoriesCurrentGroup = document.querySelector(".categories__listgroup[data-category_group='" + currentGroup + "']");
    let filter = getUrlAttr("filter");
    let isSelected = false;
    if (filter != null) {
      isSelected = getUrlAttr("filter").includes(result.path.join("|"));
    }
    if (result.path.length < 3) {
      let groupItem = `
                    <li class="list-group-item justify-content-between categories__listitem">
                    <div class="categories__listitem__checkbox">
                        
                        <input type="checkbox" id="${result.path}" class="categories__listcheck" ${isSelected ? "checked" : ""} data-category_group="${result.groupName
        }" data-category_select="${result.path.join("|")}">
                        <label for="${result.path}">${result.categoryDisplayName} (${result.itemsCount})
                        </label>
                    </div>
                    </li>
                `;
      categoriesCurrentGroup.innerHTML += groupItem;
    }
  });
};
const formatDebugItem = (item) => {
  return (
    `
        <h2>` +
    item.title +
    `</h2>` +
    item.extracts.split("<b>").join("<br/><b>") +
    "<br/><br/>"
  );
};
const formatStatsItem = (item) => {
  let regexp_old =
    /version:\s(?<ver>.*) Total no of items:\s*(?<items>.*) Active items:\s*(?<active>.*) Deleted items:\s*(?<deleted>.*) Last item id:\s*(?<lastid>.*) Last item date:\s*(?<lastitemdate>.*) Memory working set:\s*(?<memworking>.*) Free memory:\s*(?<memfree>.*) Threads in use:\s*(?<threads>.*) Index diskspace usage:\s*(?<diskusage>.*) Free space on index drive:\s*(?<diskfree>.*) Physical processors:\s*(?<processors>.*) Physical cores:\s*(?<cores>.*) Logical cores:\s*(?<coreslogical>.*) OS version:\s*(?<osver>.*) 64bit OS:\s*(?<os64bit>.*) \d{2}bit process:\s*(?<proc64bit>.*)\.NET version:\s*(?<netver>.*) Current directory:\s*(?<dir>.*) Machine name:\s*(?<machine>.*) User:\s*(?<user>.*) \[Interactive:\s*(?<interactive>.*)\]/i;
  let regexp =
    /version:\s(?<ver>.*?)<.*Total no of items:\s*(?<items>.*?)<.*Active items:\s*(?<active>.*?)<.*Deleted items:\s*(?<deleted>.*?)<.*Last item id:\s*(?<lastid>.*?)<.*Last item date:\s*(?<lastitemdate>.*?)<.*Memory working set:\s*(?<memworking>.*?)<.*Free memory:\s*(?<memfree>.*?)<.*Threads in use:\s*(?<threads>.*?)<.*Index diskspace usage:\s*(?<diskusage>.*?)<.*Free space on index drive:\s*(?<diskfree>.*?)<.*Physical processors:\s*(?<processors>.*?)<.*Physical cores:\s*(?<cores>.*?)<.*Logical cores:\s*(?<coreslogical>.*?)<.*OS version:\s*(?<osver>.*?)<.*64bit OS:\s*(?<os64bit>.*?)<.*\d{2}bit process:\s*(?<proc64bit>.*?)<.*\.NET version:\s*(?<netver>.*?)<.*Current directory:\s*(?<dir>.*?)<.*Machine name:\s*(?<machine>.*?)<.*User:\s*(?<user>.*?) \[Interactive:\s*(?<interactive>.*?)\]/i;

  let matchObj = regexp.exec(item);

  return debugHtml(matchObj);
};
const BuildQueryFilter = (filter) => {
  let queryFilter = `[ { values: ["contentSubscribers", "${window.config.clientId}"] },`;

  queryFilter += ` { values: ["Language", "nb_no"] }`;

  if (filter != null) {
    filter.split(";").forEach(function (filterPart, index) {
      if (filterPart != "") {
        queryFilter += `{ values: ["${filterPart.split("|")[0]}", "${filterPart.split("|")[1]}"] },`;
      }
    });
  }
  queryFilter += `]`;

  return queryFilter;
};
export const resetToFirstPage = () => {
  hits__from = 0;
  prev__page = Number(hits__from) - Number(hits__pr__page);
  next__page = Number(hits__from) + Number(hits__pr__page);
  document.querySelector(".searchresult__list").innerHtml = "";
  UpdateQueryString("hits__from", hits__from);
};
const addEventListners = () => {
  //Category group header Click
  document.querySelectorAll(".categories__listheader").forEach((item) => {
    item.addEventListener("click", (event) => {
      item.classList.toggle("closed");
      item.closest(".categories__group").querySelector(".categories__listgroup").classList.toggle("categories__listgroup-closed");
    });
  });

  //Category click
  document.querySelectorAll(".categories__listitem input").forEach((item) => {
    item.addEventListener("click", function () {
      filterText = "";
      document.querySelectorAll("input.categories__listcheck:checked").forEach((item) => {
        filterText += item.getAttribute("data-category_select") + ";";
      });
      UpdateQueryString("filter", filterText);
      resetToFirstPage();
      haiveFind(query__text, filterText);
    });
  });

  document.querySelectorAll(".searchresult__pagination a").forEach((item) => {
    item.addEventListener("click", function () {
      if (item.classList.contains("searchresult__prev__page")) {
        hits__from = Number(prev__page);
      } else if (item.classList.contains("searchresult__next__page")) {
        hits__from = Number(next__page);
      }
      prev__page = Number(hits__from) - Number(hits__pr__page);
      next__page = Number(hits__from) + Number(hits__pr__page);

      UpdateQueryString("hits__from", hits__from);
      haiveFind(query__text, filterText);
      var elmnt = document.getElementById("mainCol");
      elmnt.scrollIntoView();
    });
  });
};
